<template>
  <vb-icon :name="icon" :color="color" :size="size"></vb-icon>
</template>

<script>
import { is_child, is_infant } from "@liveflight/utilities/mixins";

export default {
  name: "traveler-icon",
  props: {
    traveler: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: () => "#000",
    },
    size: {
      type: Number,
      default: () => 18,
    },
  },
  methods: {
    is_infant,
    is_child,
  },
  computed: {
    icon() {
      if (this.is_infant(this.traveler)) {
        return "infant";
      }
      if (this.is_child(this.traveler)) {
        return "child";
      }
      return "user";
    },
  },
};
</script>

<style lang="scss" scoped></style>
